// @flow
/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import _ from "lodash"
import RDatePicker from "react-datepicker"
import Input from "react-toolbox/lib/input/Input"
import moment from "moment"

import "react-datepicker/dist/react-datepicker-cssmodules.css"

class DatePickerCustomInput extends Component {
  props: {
    onChange?: ( String ) => any,
    className?: String,
    inputClassName?: String,
    style?: any,
  }

  render () {
    return (
      <Input
        {..._.omit( this.props, [ "inputClassName" ] )}
        className={[ this.props.className, this.props.inputClassName ].join( " " )}
        onChange={value => this.props.onChange( {
          target: {
            value,
          },
        } )}
      />
    )
  }
}

export default class DatePicker extends Component {
  props: {
    className?: String,
    inputClassName?: String,
    onChange?: ( Date ) => any,
    value: Date,
    minDate?: Date,
    maxDate?: Date,
  }

  handleChange = momentDate => {
    this.props.onChange( momentDate && momentDate.toDate() )
  }

  render () {
    const { value, minDate, maxDate } = this.props
    return (
      <RDatePicker
        locale="pt"
        autoOk
        sundayFirstDayOfWeek
        disabledKeyboardNavigation
        {..._.omit( this.props, [ "value" ] )}
        onChange={this.handleChange}
        minDate={minDate && moment( minDate )}
        maxDate={maxDate && moment( maxDate )}
        selected={value && moment( value )}
        className={[
          style.reactDatePicker,
          this.props.className || "",
        ].join( " " )}
        customInput={
          <DatePickerCustomInput
            {..._.pick( this.props, [
              "label", "error", "icon",
              "disabled", "inputClassName",
            ] )}
          />
        }
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.jsx